<div class="modal-backdrop" *ngIf="showModal">
  <div class="modal-content-box">
    <h4 class="modal-title">Enter Your Register Mobile Number</h4>
    <form [formGroup]="mobileForm" (ngSubmit)="onMobileSubmit()">
      <input
        type="tel"
        formControlName="mobileNo"
        placeholder="Enter 10-digit Mobile Number"
        class="form-control mb-2"
      />
      <div
        *ngIf="
          mobileForm.get('mobileNo')?.touched &&
          mobileForm.get('mobileNo')?.invalid
        "
        class="text-danger small mb-2"
      >
        Please enter a valid 10-digit mobile number.
      </div>
      <div *ngIf="mobileErrorMessage" class="text-danger mb-2">
        {{ mobileErrorMessage }}
      </div>
      <button
        type="submit"
        class="btn btn-accent w-100"
        [disabled]="mobileForm.invalid"
      >
        Submit
      </button>
    </form>
  </div>
</div>

<!-- Enrolment Form -->
<ng-container *ngIf="!showModal">
  <div class="membership-form-container pt-3">
    <!-- Top Header -->
    <div class="form-main-header">
      <div class="title">AZEAPP MEMBERSHIP ENROLMENT FORM</div>
      <div class="slanted-box">
        <img src="assets/aze.png" alt="AZ Logo" class="slanted-logo" />
      </div>
    </div>

    <form
      [formGroup]="enrolmentForm"
      (ngSubmit)="onEnrolmentSubmit()"
      novalidate
    >
      <!-- Verified Business Details -->
      <div class="form-section">
        <div class="form-section-header">Verified Business Details</div>
        <div class="form-grid">
          <div class="row gx-3 full">
            <div class="col-md-6">
              <label
                >Workshop Name (As per GST)
                <span class="required-asterisk">*</span></label
              >
              <input
                type="text"
                formControlName="workshopName"
                class="form-control"
                autocomplete="off"
                [ngClass]="{ 'is-invalid': submitted && f.workshopName.errors }"
              />
              <div
                *ngIf="submitted && f.workshopName.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.workshopName.errors.required">
                  Work Shop Name is required
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Trade Name (if different)</label>
              <input
                type="text"
                formControlName="tradeName"
                class="form-control"
                autocomplete="off"
              />
            </div>
          </div>

          <div class="row gx-3 full">
            <div class="col-md-6">
              <label
                >Workshop Type <span class="required-asterisk">*</span></label
              >
              <select
                formControlName="workshopType"
                class="form-select"
                [ngClass]="{ 'is-invalid': submitted && f.workshopType.errors }"
              >
                <option value="" disabled>Select type</option>
                <option>Proprietorship</option>
                <option>Partnership</option>
                <option>Pvt Ltd</option>
                <option>LLP</option>
                <option>Franchisee</option>
              </select>

              <div
                *ngIf="submitted && f.workshopType.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.workshopType.errors.required">
                  Workshop Type is required
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label>Branch Name
                <span class="required-asterisk">*</span></label>
              <input
                type="text"
                formControlName="branchName"
                class="form-control"
                autocomplete="off"
                [ngClass]="{ 'is-invalid': submitted && f.branchName.errors }"
              />
              <div
                *ngIf="submitted && f.branchName.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.branchName.errors.required">
                  Branch Name is required
                </div>
              </div>
            </div>
          </div>

           <div class="row gx-3 full">
            <div class="col-md-6">
              <label>GST Number </label>
              <input
                type="text"
                formControlName="gstNo"
                class="form-control"
                autocomplete="off"
              />
            </div>

            <div class="col-md-6">
              <label>Workshop PAN Number</label>
              <input type="text" formControlName="panNo" class="form-control" />
            </div>
          </div>
          <div class="form-item form-item-full">
            <label>Full Address <span class="required-asterisk">*</span></label>
            <textarea
              formControlName="workshopAddress"
              class="form-control"
              rows="2"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': submitted && f.workshopAddress.errors
              }"
            ></textarea>
            <div
              *ngIf="submitted && f.workshopAddress.errors"
              class="invalid-feedback"
            >
              <div *ngIf="submitted && f.workshopAddress.errors.required">
                Workshop Address is required
              </div>
            </div>
          </div>

          <div class="row gx-3 full">
            <div class="col-md-6">
              <label>State <span class="required-asterisk">*</span></label>
              <select
                formControlName="stateId"
                class="form-select"
                (change)="onStateChange($event)"
                [ngClass]="{ 'is-invalid': submitted && f.stateId.errors }"
              >
                <option value="" disabled selected>Select State</option>
                <option *ngFor="let state of stateList" [value]="state.id">
                  {{ state.state }}
                </option>
              </select>

              <div
                *ngIf="submitted && f.stateId.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.stateId.errors.required">
                  State Name is required
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label>City <span class="required-asterisk">*</span></label>
              <select
                formControlName="cityId"
                class="form-select"
                [ngClass]="{ 'is-invalid': submitted && f.cityId.errors }"
              >
                <option value="" disabled selected>Select City</option>
                <option *ngFor="let city of cityList" [value]="city.id">
                  {{ city.city }}
                </option>
              </select>

              <div
                *ngIf="submitted && f.cityId.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.cityId.errors.required">
                  City Name is required
                </div>
              </div>
            </div>
          </div>

          <div class="row gx-3 full">
            <div class="col-md-6">
              <label>Pin Code <span class="required-asterisk">*</span></label>
              <input
                type="text"
                formControlName="pincode"
                class="form-control"
                autocomplete="off"
                (keypress)="allowOnlyNumbers($event)"
                [ngClass]="{ 'is-invalid': submitted && f.pincode.errors }"
              />
              <div
                *ngIf="submitted && f.pincode.errors"
                class="invalid-feedback"
              >
                <div *ngIf="f.pincode.errors.required">
                  Pincode is required
                </div>
                <div *ngIf="f.pincode.errors.pattern">
                  Please enter a valid 6‑digit PinCode.
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label d-flex align-items-center">
                Google Map Code <span class="required-asterisk">*</span>
                <i
                  class="fas fa-info-circle tooltip-icon ms-2 position-relative"
                >
                  <span class="tooltip-image">
                    <img
                      src="assets/plus-code-guide.png"
                      alt="How to find Google Plus Code"
                    />
                  </span>
                </i>
              </label>
              <input
                type="text"
                formControlName="locationCode"
                class="form-control"
                autocomplete="off"
                [ngClass]="{ 'is-invalid': submitted && f.locationCode.errors }"
              />
              <div
                *ngIf="submitted && f.locationCode.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.locationCode.errors.required">
                  Location Code is required
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <!-- Ownership & Team Details -->
      <div class="form-section">
        <div class="form-section-header">Ownership & Team Details</div>
        <div class="form-grid">
          <div class="row gx-3 full">
            <div class="col-md-4">
              <label>Owner Name<span class="required-asterisk">*</span></label>
              <input
                type="text"
                formControlName="ownerName"
                class="form-control"
                autocomplete="off"
                (keypress)="allowOnlyText($event)"
                [ngClass]="{ 'is-invalid': submitted && f.ownerName.errors }"
              />
              <div
                *ngIf="submitted && f.ownerName.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.ownerName.errors.required">
                  Owner Name is required
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label
                >Contact Number <span class="required-asterisk">*</span></label
              >
              <input
                type="tel"
                formControlName="mobileNo"
                class="form-control"
                autocomplete="off"
                (keypress)="allowOnlyNumbers($event)"
                [ngClass]="{ 'is-invalid': submitted && f.mobileNo.errors }"
              />
              <div
                *ngIf="submitted && f.mobileNo.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.mobileNo.errors.required">
                  Contact Number is required
                </div>
                <div *ngIf="submitted && f.mobileNo.errors.pattern">
                    Please enter a valid 10‑digit mobile number.
                  </div>
              </div>
            </div>
            <div class="col-md-4">
              <label>Alternate Number</label>
              <input
                type="tel"
                formControlName="alternateMobileNo"
                class="form-control"
                (keypress)="allowOnlyNumbers($event)"
              />
            </div>
          </div>
          <div class="row gx-3 full">
            <div class="col-md-4">
              <label
                >Number of Mechanics
                <span class="required-asterisk">*</span></label
              >
              <input
                type="text"
                formControlName="noOfMechanics"
                autocomplete="off"
                (keypress)="allowOnlyNumbers($event)"
                [ngClass]="{
                  'is-invalid': submitted && f.noOfMechanics.errors
                }"
              />
              <div
                *ngIf="submitted && f.noOfMechanics.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.noOfMechanics.errors.required">
                  No of Mechanics is required
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label
                >Service Manager Name
                <span class="required-asterisk">*</span></label
              >
              <input
                type="text"
                formControlName="managerName"
                autocomplete="off"
                (keypress)="allowOnlyText($event)"
                [ngClass]="{ 'is-invalid': submitted && f.managerName.errors }"
              />
              <div
                *ngIf="submitted && f.managerName.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.managerName.errors.required">
                  Manager Name is required
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label
                >Service Manager Contact
                <span class="required-asterisk">*</span></label
              >
              <input
                type="text"
                formControlName="managerContact"
                autocomplete="off"
                [ngClass]="{
                  'is-invalid': submitted && f.managerContact.errors
                }"
                (keypress)="allowOnlyNumbers($event)"
              />
              <div
                *ngIf="submitted && f.managerContact.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.managerContact.errors.required">
                  Manager Contact No is required
                </div>
                <div *ngIf="submitted && f.managerContact.errors.pattern">
                    Please enter a valid 10‑digit mobile number.
                </div>
              </div>
            </div>
          </div>

          <div class="row gx-3 full">
            <div class="col-md-4">
              <label
                >Working Days/Hours
                <span class="required-asterisk">*</span></label
              >
              <input
                type="text"
                formControlName="workingDaysOrHours"
                autocomplete="off"
                [ngClass]="{
                  'is-invalid': submitted && f.workingDaysOrHours.errors
                }"
              />
              <div
                *ngIf="submitted && f.workingDaysOrHours.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.workingDaysOrHours.errors.required">
                  Working Days/Hours is required
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label
                >Weekly Holiday <span class="required-asterisk">*</span></label
              >
              <input
                type="text"
                formControlName="weeklyHoliday"
                autocomplete="off"
                [ngClass]="{
                  'is-invalid': submitted && f.weeklyHoliday.errors
                }"
              />
              <div
                *ngIf="submitted && f.weeklyHoliday.errors"
                class="invalid-feedback"
              >
                <div *ngIf="submitted && f.weeklyHoliday.errors.required">
                  Weekly Holiday is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Infrastructure Profile -->
      <div class="form-section">
        <div class="form-section-header">Infrastructure Profile</div>
        <div class="form-grid">
          <div class="form-row-inline">
            <label class="form-label"
              >Premises <span class="required-asterisk">*</span> :</label
            >
            <div class="form-check-group-inline">
              <label>
                <input
                  type="radio"
                  formControlName="isOwnedOrRented"
                  value="1"
                />
                Owned
              </label>
              <label>
                <input
                  type="radio"
                  formControlName="isOwnedOrRented"
                  value="2"
                />
                Rented
              </label>
            </div>
            <div
              *ngIf="
                submitted &&
                (!f.isOwnedOrRented.value || f.isOwnedOrRented.value === null)
              "
              class="text-danger mt-1"
            >
              This Field is required
            </div>
          </div>
          <div>
            <label
              >No. of Service Bays
              <span class="required-asterisk">*</span></label
            >
            <input
              type="text"
              formControlName="serviceBays"
              autocomplete="off"
              (keypress)="allowOnlyNumbers($event)"
              [ngClass]="{ 'is-invalid': submitted && f.serviceBays.errors }"
            />
            <div
              *ngIf="submitted && f.serviceBays.errors"
              class="invalid-feedback"
            >
              <div *ngIf="submitted && f.serviceBays.errors.required">
                Service Bays is required
              </div>
            </div>
          </div>
        </div>

        <div class="business-grid">
          <div class="full ms-2">
            <label class="form-label"
              >Tools & Equipment Available
              <span class="required-asterisk">*</span></label
            >
            <div class="nature-of-business-list">
              <div
                *ngFor="let tool of equipmentList; let i = index"
                class="form-check mb-2"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="tool"
                  (change)="onCheckboxChange(tool, 'equipments', $event)"
                  [checked]="f.equipments?.value?.includes(tool)"
                  [id]="sanitizeId(tool + i)"
                />

                <label
                  class="form-check-label ms-2"
                  [for]="sanitizeId(tool + i)"
                >
                  {{ tool }}
                </label>
              </div>
            </div>

            <div class="mt-2" *ngIf="f.equipments?.value?.includes('Others')">
              <label>If Others, specify</label>
              <input
                type="text"
                class="form-control"
                formControlName="equipmentsOthers"
              />
            </div>

            <div
              *ngIf="
                submitted &&
                (!f.equipments.value || f.equipments.value.length === 0)
              "
              class="text-danger mt-1"
            >
              Please select at least one.
            </div>
          </div>
        </div>

        <div class="form-grid">
          <div class="full">
            <div class="form-row-inline">
              <label class="form-label"
                >Customer Waiting Area
                <span class="required-asterisk">*</span> :
              </label>
              <div class="form-check-group-inline">
                <label>
                  <input
                    type="radio"
                    formControlName="customerWaitingArea"
                    value="1"
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    formControlName="customerWaitingArea"
                    value="2"
                  />
                  No
                </label>
              </div>
            </div>
            <div
              *ngIf="
                submitted &&
                (!f.customerWaitingArea.value ||
                  f.customerWaitingArea.value === null)
              "
              class="text-danger mt-1 ms-3"
            >
              This Field is required
            </div>
          </div>
          <div class="full">
            <div class="form-row-inline">
              <label class="form-label"
                >Billing Counter With Printer
                <span class="required-asterisk">*</span> :
              </label>
              <div class="form-check-group-inline">
                <label>
                  <input
                    type="radio"
                    formControlName="billingCounterWithPrinter"
                    value="1"
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    formControlName="billingCounterWithPrinter"
                    value="2"
                  />
                  No
                </label>
              </div>
            </div>
            <div
              *ngIf="
                submitted &&
                (!f.billingCounterWithPrinter.value ||
                  f.billingCounterWithPrinter.value === null)
              "
              class="text-danger mt-1 ms-3"
            >
              This Field is required
            </div>
          </div>
          <div class="full">
            <div class="form-row-inline">
              <label class="form-label"
                >Do you use any Workshop Management Software (WMS)?
                <span class="required-asterisk">*</span> :
              </label>
              <div class="form-check-group-inline">
                <label>
                  <input type="radio" formControlName="isWms" value="1" />
                  Yes
                </label>
                <label>
                  <input type="radio" formControlName="isWms" value="2" />
                  No
                </label>
              </div>
            </div>

            <!-- Conditionally shown WMS Name input -->
            <div *ngIf="f.isWms.value == '1'" class="mt-2 ms-3">
              <label class="form-label">WMS Name</label>
              <input
                type="text"
                formControlName="wmsName"
                class="form-control"
              />
            </div>

            <div
              *ngIf="submitted && (!f.isWms.value || f.isWms.value === null)"
              class="text-danger mt-1 ms-3"
            >
              This Field is required
            </div>
          </div>
          <div class="full">
            <div class="form-row-inline">
              <label class="form-label"
                >Are you open to adopting AzeApp’s tech solutions?
                <span class="required-asterisk">*</span> :
              </label>
              <div class="form-check-group-inline">
                <label>
                  <input
                    type="radio"
                    formControlName="azeappSolutionAdoption"
                    value="1"
                  />
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    formControlName="azeappSolutionAdoption"
                    value="2"
                  />
                  No
                </label>
              </div>
            </div>
            <div
              *ngIf="
                submitted &&
                (!f.azeappSolutionAdoption.value ||
                  f.azeappSolutionAdoption.value === null)
              "
              class="text-danger mt-1 ms-3"
            >
              This Field is required
            </div>
          </div>
        </div>
      </div>

      <!-- Banking & Payment Details -->
      <div class="form-section">
        <div class="form-section-header">Banking & Payment Details (optional)</div>
        <div class="form-grid">
          <div class="row gx-3 full">
            <div class="col-md-4">
              <label>Bank Name </label>
              <input
                type="text"
                formControlName="bankName"
                autocomplete="off"
              />
            </div>
            <div class="col-md-4">
              <label>Account Holder Name </label>
              <input
                type="text"
                formControlName="accountHolderName"
                autocomplete="off"
                (keypress)="allowOnlyText($event)"
              />
            </div>
            <div class="col-md-4">
              <label>Account Number </label>
              <input
                type="text"
                formControlName="accountNumber"
                autocomplete="off"
                (keypress)="allowOnlyNumbers($event)"
              />
            </div>
          </div>

          <div class="row gx-3 full">
            <div class="col-md-4">
              <label>IFSC Code </label>
              <input
                type="text"
                formControlName="ifscCode"
                autocomplete="off"
              />
            </div>
            <div class="col-md-4">
              <label>UPI ID (optional)</label>
              <input type="text" formControlName="upiId" />
            </div>
          </div>
        </div>
      </div>

      <!-- AzeApp Onboarding Agreement -->
      <div class="form-section">
        <div class="form-section-header">AzeApp Onboarding Agreement</div>
        <div class="form-grid">
          <div>
            <label
              >Minimum Monthly Sourcing Commitment (₹)
              <span class="required-asterisk">*</span></label
            >
            <input
              type="text"
              formControlName="minimumMonthlySource"
              class="form-control"
              autocomplete="off"
              (keypress)="allowOnlyNumbers($event)"
              [ngClass]="{
                'is-invalid': submitted && f.minimumMonthlySource.errors
              }"
            />
            <div
              *ngIf="submitted && f.minimumMonthlySource.errors"
              class="invalid-feedback"
            >
              <div *ngIf="submitted && f.minimumMonthlySource.errors.required">
                Minimum Monthly Source is required
              </div>
            </div>
          </div>

          <div>
            <label
              >WhatsApp Number for Official Updates
              <span class="required-asterisk">*</span></label
            >
            <input
              type="tel"
              formControlName="whatsappNumber"
              class="form-control"
              autocomplete="off"
              (keypress)="allowOnlyNumbers($event)"
              [ngClass]="{ 'is-invalid': submitted && f.whatsappNumber.errors }"
            />
            <div
              *ngIf="submitted && f.whatsappNumber.errors"
              class="invalid-feedback"
            >
              <div *ngIf="submitted && f.whatsappNumber.errors.required">
                Whatsapp Number is required
              </div>
              <div *ngIf="submitted && f.whatsappNumber.errors.pattern">
                Please enter a valid 10‑digit mobile number.
              </div>
            </div>
          </div>
        </div>

        <div class="business-grid">
          <div class="full ms-2">
            <label class="form-label"
              >Preferred Language
              <span class="required-asterisk">*</span> :</label
            >
            <div class="nature-of-business-list">
              <div
                *ngFor="let language of languageList; let i = index"
                class="form-check mb-2"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="language"
                  (change)="onCheckboxChange(language, 'language', $event)"
                  [checked]="f.language?.value?.includes(language)"
                  [id]="sanitizeId(language + i)"
                />

                <label
                  class="form-check-label ms-2"
                  [for]="sanitizeId(language + i)"
                >
                  {{ language }}
                </label>
              </div>
            </div>

            <div class="mt-2" *ngIf="f.language?.value?.includes('Others')">
              <label>If Others, specify</label>
              <input
                type="text"
                class="form-control"
                formControlName="languageOthers"
              />
            </div>

            <div
              *ngIf="
                submitted &&
                (!f.language.value || f.language.value.length === 0)
              "
              class="text-danger mt-1"
            >
              Please select at least one.
            </div>
          </div>
        </div>
      </div>

      <!-- ADDITIONAL WORKSHOPS -->

      <div class="form-section" *ngIf="additionalWorkshops.length > 0">
        <div
          class="form-section-header d-flex justify-content-between align-items-center"
        >
          <span>ADDITIONAL WORKSHOPS</span>
        </div>

        <div
          formArrayName="additionalWorkshops"
          *ngIf="additionalWorkshops.length > 0"
        >
          <div
            *ngFor="let group of additionalWorkshops.controls; let i = index"
            class="workshop-card"
          >
            <div [formGroupName]="i">
              <!-- NOW group is AbstractControl, so cast it to FormGroup via a method -->
              <ng-container *ngIf="getWorkshopGroup(i) as ws">
                <div class="row gx-3">
                  <div class="col-md-4 mb-3">
                    <label
                      >Branch Name
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="branchName"
                      class="form-control"
                      type="text"
                      autocomplete="off"
                      [ngClass]="{
                        'is-invalid': submitted && ws.get('branchName')?.errors
                      }"
                    />
                     <div *ngIf="submitted && ws.get('branchName')?.errors" class="invalid-feedback">
                        <div *ngIf="submitted && ws.get('branchName')?.errors?.required">
                          Branch Name is required.
                        </div>
                     </div>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label
                      >Manager Name
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="managerName"
                      class="form-control"
                      type="text"
                      autocomplete="off"
                      (keypress)="allowOnlyText($event)"
                      [ngClass]="{
                        'is-invalid': submitted && ws.get('managerName')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('managerName')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('managerName')?.errors?.required">
                        Manager Name is required.
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label
                      >Manager Contact
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="managerContact"
                      class="form-control"
                      type="tel"
                      autocomplete="off"
                      (keypress)="allowOnlyNumbers($event)"
                      [ngClass]="{
                        'is-invalid':
                          submitted && ws.get('managerContact')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('managerContact')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('managerContact')?.errors?.required">
                        Manager Contact No is required.
                      </div>
                      <div *ngIf="submitted && ws.get('managerContact')?.errors?.pattern">
                        Please enter a valid 10‑digit mobile number.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row gx-3">
                  <div class="col-md-4 mb-3">
                    <label
                      >No. of Mechanics
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="noOfMechanics"
                      class="form-control"
                      type="text"
                      autocomplete="off"
                      (keypress)="allowOnlyNumbers($event)"
                      [ngClass]="{
                        'is-invalid':
                          submitted && ws.get('noOfMechanics')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('noOfMechanics')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('noOfMechanics')?.errors?.required">
                        No. of Mechanics is required.
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label
                      >Working Days/Hours
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="workingDaysOrHours"
                      class="form-control"
                      placeholder="Working Days/Hours"
                      autocomplete="off"
                      [ngClass]="{
                        'is-invalid':
                          submitted && ws.get('workingDaysOrHours')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('workingDaysOrHours')?.errors"
                      class="invalid-feedback"
                    >
                      <div
                        *ngIf="submitted && ws.get('workingDaysOrHours')?.errors?.required"
                      >
                        Working Days/Hours is required.
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label
                      >Weekly Holiday
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="weeklyHoliday"
                      class="form-control"
                      placeholder="Weekly Holiday"
                      autocomplete="off"
                      [ngClass]="{
                        'is-invalid':
                          submitted && ws.get('weeklyHoliday')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('weeklyHoliday')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('weeklyHoliday')?.errors?.required">
                        Weekly Holiday is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row gx-3">
                  <div class="col-md-4 mb-3">
                    <label
                      >No. of Service Bays
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="serviceBays"
                      type="text"
                      class="form-control"
                      placeholder="Service Bays"
                      autocomplete="off"
                      (keypress)="allowOnlyNumbers($event)"
                      [ngClass]="{
                        'is-invalid': submitted && ws.get('serviceBays')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('serviceBays')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('serviceBays')?.errors?.required">
                        No. of Service Bays is required.
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label
                      >Monthly Parts Purchase Value
                      <span class="required-asterisk">*</span></label
                    >
                    <input
                      formControlName="partsStockValue"
                      class="form-control"
                      type="text"
                      autocomplete="off"
                      (keypress)="allowOnlyNumbers($event)"
                      [ngClass]="{
                        'is-invalid':
                          submitted && ws.get('partsStockValue')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('partsStockValue')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('partsStockValue')?.errors?.required">
                        Monthly Parts Purchase Value is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <label
                    >Full Address
                    <span class="required-asterisk">*</span></label
                  >
                  <textarea
                    formControlName="workshopAddress"
                    class="form-control"
                    rows="2"
                    autocomplete="off"
                    [ngClass]="{
                      'is-invalid':
                        submitted && ws.get('workshopAddress')?.errors
                    }"
                  ></textarea>

                  <div
                    *ngIf="submitted && ws.get('workshopAddress')?.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="submitted && ws.get('workshopAddress')?.errors?.required">
                      Workshop Address is required.
                    </div>
                  </div>
                </div>

                <div class="row gx-3">
                  <div class="col-md-4 mb-3">
                    <label
                      >State <span class="required-asterisk">*</span></label
                    >
                    <select
                      formControlName="stateId"
                      class="form-select"
                      (change)="onStateChanges($event, i)"
                      [ngClass]="{
                        'is-invalid': submitted && ws.get('stateId')?.errors
                      }"
                    >
                      <option value="" disabled selected>Select State</option>
                      <option
                        *ngFor="let state of stateList"
                        [value]="state.id"
                      >
                        {{ state.state }}
                      </option>
                    </select>

                    <div
                      *ngIf="submitted && ws.get('stateId')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('stateId')?.errors?.required">
                        State Name is required
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label
                      >City <span class="required-asterisk">*</span></label
                    >
                    <select
                      formControlName="cityId"
                      class="form-select"
                      [ngClass]="{
                        'is-invalid': submitted && ws.get('cityId')?.errors
                      }"
                    >
                      <option value="" disabled selected>Select City</option>
                      <option
                        *ngFor="let city of cityLists[i]"
                        [value]="city.id"
                      >
                        {{ city.city }}
                      </option>
                    </select>

                    <div
                      *ngIf="submitted && ws.get('cityId')?.errors"
                      class="invalid-feedback"
                    >
                       <div *ngIf="submitted && ws.get('cityId')?.errors?.required">
                        City Name is required
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4 mb-3">
                    <label
                      >Pin Code <span class="required-asterisk">*</span></label
                    >
                    <input
                      type="text"
                      formControlName="pincode"
                      class="form-control"
                      autocomplete="off"
                      (keypress)="allowOnlyNumbers($event)"
                      [ngClass]="{
                        'is-invalid': submitted && ws.get('pincode')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('pincode')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('pincode')?.errors?.required">
                        Pincode is required.
                      </div>
                      <div *ngIf="submitted && ws.get('pincode')?.errors?.pattern">
                        Please enter a valid 6‑digit PinCode.
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row gx-3">
                  <div class="col-md-4 mb-3">
                    <label>Landmark</label>
                    <input
                      type="text"
                      formControlName="landmark"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-4 mb-3">
                    <label class="form-label d-flex align-items-center">
                      Google Map Code <span class="required-asterisk">*</span>
                      <i
                        class="fas fa-info-circle tooltip-icon ms-2 position-relative"
                      >
                        <span class="tooltip-image">
                          <img
                            src="assets/plus-code-guide.png"
                            alt="How to find Google Plus Code"
                          />
                        </span>
                      </i>
                    </label>

                    <input
                      type="text"
                      formControlName="locationCode"
                      class="form-control"
                      autocomplete="off"
                      [ngClass]="{
                        'is-invalid':
                          submitted && ws.get('locationCode')?.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && ws.get('locationCode')?.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="submitted && ws.get('locationCode')?.errors?.required">
                        Location Code is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="full">
                  <div class="mb-3 form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      formControlName="isAzeappUsernameNo"
                      id="isAzeappUsernameNo{{ i }}"
                    />
                    <label
                      class="form-check-label"
                      [for]="'isAzeappUsernameNo' + i"
                    >
                      Use Manager Contact Number as AzeApp Username
                    </label>
                  </div>
                </div>

                <div
                  class="col-md-4 mb-3"
                  *ngIf="!ws.get('isAzeappUsernameNo')?.value"
                >
                  <label
                    >AzeApp Username Mobile Number
                    <span class="required-asterisk">*</span></label
                  >
                  <input
                    formControlName="azeappMblNo"
                    class="form-control"
                    type="tel"
                    autocomplete="off"
                    (keypress)="allowOnlyNumbers($event)"
                    [ngClass]="{
                      'is-invalid': submitted && ws.get('azeappMblNo')?.errors
                    }"
                  />
                  <div
                    *ngIf="submitted && ws.get('azeappMblNo')?.errors"
                    class="invalid-feedback"
                  >
                    <div *ngIf="submitted && ws.get('azeappMblNo')?.errors?.required">
                      AzeApp Username Mobile No is required.
                    </div>
                    <div *ngIf="submitted && ws.get('azeappMblNo')?.errors?.pattern">
                       Please enter a valid 10‑digit mobile number.
                    </div>
                  </div>
                </div>

                <div class="full">
                  <div class="form-row-inline">
                    <label class="form-label"
                      >Premises
                      <span class="required-asterisk">*</span> :</label
                    >
                    <div class="form-check-group-inline">
                      <label>
                        <input
                          type="radio"
                          formControlName="isOwnedOrRented"
                          value="1"
                        />
                        Owned
                      </label>
                      <label>
                        <input
                          type="radio"
                          formControlName="isOwnedOrRented"
                          value="2"
                        />
                        Rented
                      </label>
                    </div>
                    <div
                      *ngIf="
                        submitted &&
                        (!ws.get('isOwnedOrRented').value ||
                          ws.get('isOwnedOrRented').value === null)
                      "
                      class="text-danger mt-1"
                    >
                      This Field is required
                    </div>
                  </div>
                </div>
                <div class="full">
                  <div class="form-row-inline">
                    <label class="form-label"
                      >Customer Waiting Area
                      <span class="required-asterisk">*</span> :
                    </label>
                    <div class="form-check-group-inline">
                      <label>
                        <input
                          type="radio"
                          formControlName="customerWaitingArea"
                          value="1"
                        />
                        Yes
                      </label>
                      <label>
                        <input
                          type="radio"
                          formControlName="customerWaitingArea"
                          value="2"
                        />
                        No
                      </label>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      submitted &&
                      (!ws.get('customerWaitingArea').value ||
                        ws.get('customerWaitingArea').value.value === null)
                    "
                    class="text-danger mt-1 ms-3"
                  >
                    This Field is required
                  </div>
                </div>
                <div class="full">
                  <div class="form-row-inline">
                    <label class="form-label"
                      >Billing Counter With Printer
                      <span class="required-asterisk">*</span> :
                    </label>
                    <div class="form-check-group-inline">
                      <label>
                        <input
                          type="radio"
                          formControlName="billingCounterWithPrinter"
                          value="1"
                        />
                        Yes
                      </label>
                      <label>
                        <input
                          type="radio"
                          formControlName="billingCounterWithPrinter"
                          value="2"
                        />
                        No
                      </label>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      submitted &&
                      (!ws.get('billingCounterWithPrinter').value ||
                        ws.get('billingCounterWithPrinter').value === null)
                    "
                    class="text-danger mt-1 ms-3"
                  >
                    This Field is required
                  </div>
                </div>
                <div class="business-grid">
                  <div class="full">
                    <label class="form-label"
                      >Tools & Equipment Available
                      <span class="required-asterisk">*</span></label
                    >
                    <div class="nature-of-business-list">
                      <div
                        *ngFor="let tool of equipmentList; let i = index"
                        class="form-check mb-2"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [value]="tool"
                          (change)="
                            onCheckboxChange(tool, 'equipments', $event, ws)
                          "
                          [checked]="
                            ws.get('equipments')?.value?.includes(tool)
                          "
                          [id]="sanitizeId(tool + i)"
                        />

                        <label
                          class="form-check-label ms-2"
                          [for]="sanitizeId(tool + i)"
                        >
                          {{ tool }}
                        </label>
                      </div>
                    </div>

                    <div
                      class="mt-2"
                      *ngIf="ws.get('equipments')?.value?.includes('Others')"
                    >
                      <label>If Others, specify</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="equipmentsOthers"
                      />
                    </div>

                    <div
                      *ngIf="
                        submitted &&
                        (!ws.get('equipments')?.value ||
                          ws.get('equipments')?.value.length === 0)
                      "
                      class="text-danger mt-1"
                    >
                      Please select at least one.
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Owner Declarations & Consent-->
      <div class="form-section">
        <div class="form-section-header">Owner Declarations & Consent</div>
        <div class="azeapp-expectations-list">
          <div
            *ngFor="let item of declarationsList; let i = index"
            class="form-check"
          >
            <input
              type="checkbox"
              class="form-check-input"
              [value]="item"
              (change)="onCheckboxChange(item, 'declarations', $event)"
              [checked]="f.declarations?.value?.includes(item)"
              [id]="sanitizeId(item + i)"
            />

            <label class="form-check-label ms-2" [for]="sanitizeId(item + i)">
              {{ item }}
            </label>
          </div>

          <div>
            <button
              type="button"
              class="btn btn-link p-0"
              (click)="openTermsModal()"
            >
              View Full Terms & Conditions and confirm
            </button>
          </div>
          <div *ngIf="showTermsError" class="text-danger mt-1">
            You must agree to the Terms & Conditions before submitting.
          </div>
        </div>
      </div>

      <!-- SUBMIT -->
      <div class="text-center mt-4">
        <button type="submit" class="btn btn-success">
          Submit Application
        </button>
      </div>
    </form>
  </div>
</ng-container>

<div class="custom-modal-backdrop" *ngIf="showTermsModal">
  <div class="custom-modal-box">
    <div class="custom-modal-header">
      <p><strong>Terms of Use</strong><br />(Effective {{ effectiveDate }})</p>
      <button type="button" class="btn-close" (click)="closeTermsModal()">
        &times;
      </button>
    </div>
    <div class="custom-modal-body">
      <p><strong>IMPORTANT — PLEASE READ CAREFULLY.</strong></p>
      <p>
        By clicking “I Agree,” signing the Membership Application, or placing
        any order through the AzeApp platform, you (“Member,” “you,” or “your”)
        acknowledge that you have read, understood, and agree to be bound by
        these Terms of Use (“Terms”). If you do not agree, do not activate,
        access, or use the AzeApp services.
      </p>

      <h6>1. Definitions</h6>
      <ul>
        <li>
          <strong>“AzeApp,” “we,” “our,” “us”</strong> – Azelerator
          Mobility Pvt Ltd and its affiliates.
        </li>
        <li>
          <strong>“Platform”</strong> – AzeApp’s web portal, mobile application,
          dashboards, APIs, and any related services.
        </li>
        <li>
          <strong>“Workshop”</strong> – The multi‑brand vehicle‑service facility
          identified in your Membership Application.
        </li>
        <li>
          <strong>“Spare Parts”</strong> – Automotive spare parts, accessories,
          consumables, and related products offered on the Platform.
        </li>
      </ul>

      <h6>2. Eligibility</h6>
      <p>
        You must (a) hold a valid business licence; (b) operate a physical
        multi‑brand workshop within India; (c) not be subject to insolvency
        proceedings; and (d) complete KYC verification to our satisfaction.
      </p>

      <h6>3. Enrollment & Membership Number</h6>
      <p>
        Membership becomes active when AzeApp issues a written confirmation
        quoting your unique Membership Number and Activation Date. AzeApp may
        accept or reject any application at its sole discretion.
      </p>

      <h6>4. Scope of Services</h6>
      <ul>
        <li>Smart sourcing of spare parts through our platform.</li>
        <li>Order, payment, return, and logistics management tools.</li>
        <li>Insurance cashless tie-ups.</li>
        <li>Other benefits from time to time.</li>
      </ul>

      <h6>5. Membership Conduct & Compliance</h6>
      <ul>
        <!-- <li>
          <strong>5.1 Minimum Sourcing Commitment:</strong> Member shall procure
          ≥ 90 % of its monthly spare‑parts requirements for the Workshop
          exclusively through AzeApp. Failure for two (2) consecutive months may
          lead to suspension, downgrade of benefits, or termination.
        </li>
        <li>
          <strong>5.2 Data Accuracy:</strong> Provide true, complete, and
          up‑to‑date business, inventory, and transaction data.
        </li> -->
        <li>
          <strong>5.1 Credential Security:</strong> Keep Platform credentials
          confidential; notify AzeApp immediately of any breach.
        </li>
        <li>
          <strong>5.2 Brand & Area Exclusivity:</strong> Use AzeApp branding
          assets only as approved. Membership is exclusive within a 5 km radius;
          Member shall not sub‑license or transfer membership.
        </li>
        <li>
          <strong>5.3 Compliance:</strong> Adhere to all applicable laws,
          regulations, and OEM guidelines.
        </li>
      </ul>

      <h6>6. Prices, Payment & Credit</h6>
      <p>
        Prices are visible in real time on the Platform and may fluctuate
        without notice. Payment modes: prepaid, BNPL, or credit limits approved
        by AzeApp’s finance partners. Payment beyond approved credit limit
        attract interest at 18 % p.a. from the due date until cleared. AzeApp
        reserves the right to offset incentives against outstanding dues.
      </p>

      <h6>7. Orders, Delivery, Returns & Warranty</h6>
      <p>
        All terms and conditions related to order placement, return,
        replacement, pricing and estimates, delivery and warranty terms are
        detailed in the AzeApp web and mobile login.
      </p>

      <h6>8. Confidentiality & Data Protection</h6>
      <p>
        Pricing, analytics, and other non‑public information are Confidential
        Information. Both parties shall protect Confidential Information using
        reasonable safeguards and shall not disclose it to third parties except
        as required by law.
      </p>

      <h6>9. Intellectual Property</h6>
      <p>
        All trademarks, logos, software, and content on the Platform are
        AzeApp’s property or licensed thereto. Member is granted a limited,
        non‑exclusive, revocable licence to use the Platform during the
        membership term.
      </p>

      <h6>10. Marketing & Publicity</h6>
      <p>
        Member authorises AzeApp to use the Workshop’s name, logo, and basic
        profile for marketing, case studies, and promotional purposes unless
        Member opts out in writing.
      </p>

      <h6>11. Term; Suspension; Termination</h6>
      <p>
        Initial Term: One (1) year from Activation Date, renewing automatically
        unless either party gives thirty (30) days’ written notice. AzeApp may
        suspend or terminate membership immediately for: (a) breach of these
        Terms (including clause 5.1); (b) unlawful conduct; (c) non‑payment
        beyond approved credit limit. Upon termination, all outstanding amounts
        become immediately due and payable, and Member must cease use of AzeApp
        branding and delete all confidential materials.
      </p>

      <h6>12. Limitation of Liability</h6>
      <p>
        To the maximum extent permitted by law, AzeApp’s aggregate liability
        shall not exceed the total service fees paid by Member in the preceding
        three (3) months. AzeApp is not liable for indirect, consequential, or
        punitive damages.
      </p>

      <h6>13. Indemnity</h6>
      <p>
        Member agrees to indemnify and hold harmless AzeApp, its directors, and
        employees from any claims, damages, or expenses arising out of (a)
        Member’s breach of these Terms; (b) violation of laws; or (c) negligence
        or misconduct.
      </p>

      <!-- <h6>14. Audit & Records</h6>
      <p>
        AzeApp may, upon reasonable notice, audit Member’s purchase records
        solely to verify compliance with the 90 % sourcing requirement. Member
        shall maintain accurate records for at least three (3) years.
      </p> -->

      <h6>14. Force Majeure</h6>
      <p>
        Neither party shall be liable for failure or delay caused by events
        beyond reasonable control, including natural disasters, strikes,
        governmental actions, or internet outages.
      </p>

      <h6>15. Modifications to Terms</h6>
      <p>
        AzeApp may amend these Terms by posting an updated version on the
        Platform and notifying Members via email or in‑app message. Continued
        use after the effective date constitutes acceptance.
      </p>

      <h6>16. Governing Law & Dispute Resolution</h6>
      <p>
        These Terms are governed by the laws of India. Any dispute shall first
        be referred to senior management for amicable resolution. If unresolved
        within thirty (30) days, the dispute shall be finally settled by
        arbitration in Chennai under the Arbitration and Conciliation Act, 1996,
        by a sole arbitrator appointed by AzeApp. The arbitral award shall be
        final and binding.
      </p>

      <h6>17. General Provisions</h6>
      <ul>
        <li>
          <strong>Entire Agreement:</strong> These Terms, along with the
          Membership Application and any policies referenced herein, constitute
          the entire agreement.
        </li>
        <li>
          <strong>Assignment:</strong> Member may not assign rights or
          obligations without AzeApp’s prior written consent.
        </li>
        <li>
          <strong>Severability:</strong> If any provision is held invalid, the
          remaining provisions will remain in full force.
        </li>
        <li>
          <strong>No Waiver:</strong> A party’s failure to enforce any right
          shall not be deemed a waiver.
        </li>
      </ul>
    </div>
    <div class="modal-footer text-center mt-4">
      <button class="btn btn-success me-2" (click)="onAgreeTerms()">
        Agree
      </button>
      <button class="btn btn-outline-secondary" (click)="closeTermsModal()">
        Cancel
      </button>
    </div>
  </div>
</div>

<div class="otp-modal-backdrop" *ngIf="showOtpModal">
  <div class="otp-modal-box shadow">
    <div class="otp-modal-header">
      <h5><i class="fas fa-shield-alt me-2 text-success"></i>Verify OTP</h5>
      <button class="btn-close" (click)="closeOtpModal()">&times;</button>
    </div>

    <div class="otp-modal-body">
      <p class="mb-3">Enter the 6-digit OTP sent to your mobile number.</p>

      <input
        type="text"
        maxlength="6"
        [(ngModel)]="otpCode"
        class="form-control text-center mb-3"
        placeholder="------"
        (keypress)="allowOnlyNumbers($event)"
      />

      <div *ngIf="otpError" class="text-danger small mb-1 text-center">
        {{ otpError }}
      </div>

      <button class="btn btn-success w-100 mb-3" (click)="verifyOtp()">
        <i class="fas fa-check-circle me-1"></i> Submit OTP
      </button>

      <div class="text-center mb-3">
        <small class="text-muted">
          Didn’t receive the OTP?
          <button
            class="btn btn-link p-0 ms-1"
            [disabled]="resendCooldown > 0"
            (click)="resendOtp()"
          >
            Resend OTP
          </button>
          <span *ngIf="resendCooldown > 0" class="text-danger">
            ({{ resendCooldown }}s)
          </span>
        </small>
      </div>

      <button class="btn btn-outline-secondary w-100" (click)="closeOtpModal()">
        Cancel
      </button>
    </div>
  </div>
</div>
